<template>
<div class="page_xianli setbg pd120">
    <div class="content infowrap">
        <div class="info" v-if="info">
            <van-image class="thumb" fit="cover" v-if="info.thumb" :src="imageUrl+info.thumb" :show-error="false" :show-loading="false" />
            <div class="zuopin">
                <div class="author">{{ info.name }}</div>
                <div class="desc">{{ info.describe }}</div>
                <div class="desc ganyan">{{ info.content }}</div>
                <div class="works">
                    <div class="top">
                        <div class="top_l">献礼作品展示</div>
                        <div class="top_r">
                            <div class="address" v-if="info.area1 || info.area2 ||  info.area3">{{  (info.area1?info.area1.areaname:'') + (info.area2?'>'+info.area2.areaname:'') + (info.area3?'>' +info.area3.areaname:'') }}</div>
                            <div class="time">{{ info.createdAt }}</div>
                        </div>
                    </div>
                    <div class="item_tu more">
                        <div class="tu_wrap" v-for="(image,index) in images_hide ? worksSlice : works" :key="index"  @click="zhanshitupian(works,index)">
                            <van-image fit="cover" :src="imageUrl+image" class="tu" :show-error="false" :show-loading="false" />
							<div class="mark" v-if="images_hide && index == 3">{{'+'+ (works.length -4)}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btnwrap small">
                <div class="btn" @click="goPublish">{{ is_publish ? '我发起的献礼' : '发起献礼' }}</div>
                <div :class="info.is_help ? 'btn zhulied' : 'btn' " @click="bindZhuli">{{ info.is_help ? '已助力' : '去助力' }}</div>
            </div>
            <!-- 助力团 -->
            <div class="zhuliwrap long">
                <div class="type">
                    <div class="tiaofu toleft">
                        <div class="line"></div>
                    </div>
                    <div class="title">助力团</div>
                    <div class="tiaofu toright">
                        <div class="line"></div>
                    </div>
                </div>
				<!-- 前五条 -->
                <div class="list">
                    <div class="thumbs">
                        <img v-for="(item,index) in zhulituanList.slice(0,5)" :style="index==0 ? 'margin-left:0' : ''" :src="item.thumb ? ($publicData.withHttpStart(item.thumb) ? item.thumb : imageUrl+item.thumb) : $publicData.defaultTouxiang" :key="index" alt="" class="tu">
                    </div>
                    <div class="tips"><span class="nums">{{zhulituanTotal}}</span>人助力</div>
                </div>
				<!-- 五条 之后 -->
				<div class="listline">
					<img v-for="(item,index) in zhulituanList.slice(5)" :src="item.thumb ? ( $publicData.withHttpStart(item.thumb) ?item.thumb : imageUrl+item.thumb) : $publicData.defaultTouxiang" :key="index" class="tu">
				</div>
            </div>
            <div class="btnmore" v-if="zhulituan.status">
                <div class="text" @click="loadMoreZhuli">查看更多</div>
            </div>
        </div> 
    </div>
	<!-- 评论区 -->
	<div class="commentwrap long" v-if="info">
		<div class="typewrap">
			<div class="type">
				<div class="tiaofu toleft">
					<div class="line"></div>
				</div>
				<div class="title">评论 {{ '('+ pinglunTotal +')' }}</div>
				<div class="tiaofu toright">
					<div class="line"></div>
				</div>
			</div>
		</div>
		<div class="list">
			<div class="item" v-for="item in pinglunList" :key="item.id">
				<van-image fit="cover" v-if="item.userdata" :src="item.userdata.thumb ? ( $publicData.withHttpStart(item.userdata.thumb) ? item.userdata.thumb : imageUrl+item.userdata.thumb) : $publicData.defaultTouxiang " class="thumb" :show-error="false" :show-loading="false" />
				<div class="item_r">
					<div class="item_r_t">
						<div class="name" v-if="item.userdata">{{ item.userdata.nickname ? item.userdata.nickname : item.userdata.username ? $publicData.formatPhone(item.userdata.username) : ''}}</div>
						<div class="time">{{ item.created_at }}</div>
					</div>
					<div class="title">{{ item.content }}</div>
				</div>
			</div>
		</div>
		<!-- 查看更多 -->
		<div class="btnmore" v-if="pinglun.status" @click="loadeMorePinglun">
			<div class="text">查看更多</div>
		</div>
	</div>
	<!-- 评论 -->
	<div class="bottom">
		<div class="comment">
			<van-field v-model="content" placeholder="说点什么吧~" />
			<div class="btnsend" @click="bindSendComment">发送</div>
		</div>
	</div>
	<!-- 返回首页 -->
	<div class="homeBtn" @click="goXianliIndex"></div>
	<!-- 大图预览 -->
    <van-image-preview v-model="bigTuShow" :start-position="bigTuIndex" :images="bigTuImgArr" @change="bigTuChange"></van-image-preview>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;
import { Dialog } from 'vant';

export default {
    name: "xianli-detail",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            imgList: [],
			content: null, // 评论内容
			from_uuid: this.$route.query.from_uuid,
			info: null,
			userInfo: null,
			works: [], // 作品
			images_hide: false, // 作品多于4个加的隐藏状态
			worksSlice: [], // 作品截取
			articleid: null,
			zhulituan: {
				page: 1,
				size: 5,
				status: false
			},
			zhulituanList: [],
			zhulituanTotal: null,
			pinglun: {
				page: 1,
				size: 5,
				status: false
			},
			pinglunList: [],
			pinglunTotal: null,
			bigTuShow: false,
            bigTuIndex: 0,
            bigTuImgArr: null,
			is_publish: 0, // 当前用户是否发布过献礼 0未发布过 1发布过, 默认为0
			status: null, // 当前用户的献礼状态 0未审核1审核通过-1未通过
			uuid: null // 当前用户的uuid
        };
    },
    components: {
        PageSearch,
    },
    created: function () {
		var that = this
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    // hiddenNavi: true,
                    naviTitle: '献礼详情',
                    // hiddenBack: true
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
						this.uuid = data.result.uuid
						this.getUserPublishState()
                    } else {
                        this.token = "";
						this.uuid = ""
                    }

                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
					that.$bridge.callhandler(
						"sdjy://member/memberInfo",
						memberParams,
						(data) => {
							if (data.code == 200) {
								that.token = data.result.token;
								that.uuid = data.result.uuid
								that.getUserPublishState()
							} else {
								that.token = "";
								that.uuid = ""
							}

						}
					);
                    // alert(JSON.stringify(data));
                    responseCallback(data);
                }
            );
        } else {
            this.token = this.$store.getters.token;
			this.uuid = this.$store.getters.uuid
        }
		// 获取数据
		this.getData()
		if(this.token){
			this.getUserPublishState()
		}
		this.showEndZhuli()
    },
	watch: {
		'$route.query': function (n, o) {
            // console.log('n',n,'o',o)
			var that = this
            if (n) {
                that.from_uuid = n.from_uuid;
				that.getUserPublishState()
                that.getData();
            }
        }
	},
    methods: {
		// 献礼详情
		getData(){
			var that = this
			var params = {
				token: that.token,
				from_uuid: that.from_uuid
			}
			that.$api.xianli.detail(params).then(res=>{
				if(res.code == 200){
					var info = res.result
					// 发布时间只截取年月日
					info.createdAt = info.created_at ? info.created_at.split(' ')[0] : ''
					that.info = info
					that.userInfo = res.result.userdata
					that.works = JSON.parse(res.result.works)
					that.articleid = res.result.id
					var images = JSON.parse(res.result.works)
					if(images && images.length > 4){
						that.worksSlice = images.slice(0,4)
						that.images_hide = true
					}
					// 配置分享
					that.getShareData()
					// 获取助力团列表
					that.zhulituan.page = 1
					that.zhulituanList = []
					that.getHelpData()
					// 获取评论列表
					that.pinglun.page = 1
					that.pinglunList = []
					that.getCommentData()
				}
			})
		},
		// 助力团
		getHelpData(){
			var that = this
			var params = {
				articleid: that.articleid,
				page: that.zhulituan.page,
				size: that.zhulituan.size
			}
			that.$api.xianli.helplist(params).then(res=>{
				if(res.code == 200){
					var list = res.result.list
					var total = res.result.total
					that.zhulituanTotal = total
					if(list && list.length != 0){
						that.zhulituanList = that.zhulituanList.concat(list)
						if(that.zhulituanList.length < total){
							that.zhulituan.status = true
						}else{
							that.zhulituan.status = false
						}
					}else{
						that.zhulituan.status = false
					}
				}
			})
		},
		// 加载更多助力团
		loadMoreZhuli(){
			var that = this
			that.zhulituan.page++
			that.getHelpData()
		},
		// 评论列表
		getCommentData(){
			var that = this
			var params = {
				articleid: that.articleid,
				page: that.pinglun.page,
				size: that.pinglun.size
			}
			that.$api.xianli.commentlist(params).then(res=>{
				if(res.code == 200){
					var list = res.result.list
					var total = res.result.total
					that.pinglunTotal = total
					if(list && list.length != 0){
						that.pinglunList = that.pinglunList.concat(list)
						if(that.pinglunList.length < total){
							that.pinglun.status = true
						}else{
							that.pinglun.status = false
						}
					}else{
						that.pinglun.status = false
					}
				}
			})
		},
		// 加载更多列表
		loadeMorePinglun(){
			var that = this
			that.pinglun.page++
			that.getCommentData()
		},
		// 发表评论
		bindSendComment(){
			this.showEndZhuli()
			return
			var that = this
			if(that.content == null || that.content == '' || that.content == undefined){
				that.$toast('请填写评论内容')
				return
			}
			if (that.token  == null || that.token == '' || that.token == undefined) {
				if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
					var memberParams = {
						data: {
						},
					};
					this.$bridge.callhandler("sdjy://member/memberInfo", memberParams, (data) => {
							if (data.code == 200) {
								this.token = data.result.token;
								this.uuid = data.result.uuid
							} else {
								this.token = "";
								this.uuid = ""
							}

						}
					);
				} else {
					localStorage.setItem('redirect', that.$router.currentRoute.fullPath)
					that.$router.push({
						path: '/login',
					})
				}
				return
			}
			var params = {
				token: that.token,
				content: that.content,
				articleid: that.articleid
			}
			that.$api.xianli.postcomment(params).then(res=>{
				if(res.code == 200){
					that.content = null
					that.$toast(res.message)
					// 重新拉取评论列表
					that.pinglun.page = 1
					that.pinglun.status = false
					that.pinglunList = []
					that.getCommentData()
				}
			})
		},
		showEndZhuli() {
			Dialog.confirm({
                title: '温馨提示',
                message: '尊敬的时代记忆用户，百年献礼活动已结束，感谢您的关注与支持。工作人员正在统计数据，排名及获奖信息将在7月份公布，敬请期待。',
                showConfirmButton:true,
                confirmButtonText: '确定',
				showCancelButton: false,
                // theme: 'round-button',
                }).then(() => {
                    
                });
		},
		// 发布献礼
		goPublish(){
			this.showEndZhuli()
			return
			var that = this
			// console.log('发布献礼=====',that.is_publish,that.status)
			// 当本条信息是当前用户发布的,给提示
			if(that.from_uuid == that.uuid){
				that.$toast('当前即为您的献礼信息')
				return
			}
			if (!that.token) {
				if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
					var memberParams = {
						data: {
						},
					};
					this.$bridge.callhandler("sdjy://member/memberInfo", memberParams, (data) => {
							if (data.code == 200) {
								this.token = data.result.token;
								this.uuid = data.result.uuid
								this.getUserPublishState()
							} else {
								this.token = "";
								this.uuid = ""
							}

						}
					);
				} else {
					localStorage.setItem('redirect', that.$router.currentRoute.fullPath)
					that.$router.push({
						path: '/login',
					})
				}
				
			}else{
				// 登录状态下的处理
				if(that.is_publish && that.status == 1 ){
					if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
						var params = {
							'data': {
								'url': that.$publicData.clientUrl + '/xianli/detail?from_uuid='+ that.uuid
							}
						}
						that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

						})
					} else {
						// 通过审核
						that.$router.push({
							path: '/xianli/detail',
							query: {
								from_uuid: that.uuid
							}
						})
					}
					
					
				} else if(that.is_publish && that.status != 1){
					if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
						var params = {
							'data': {
								'url': that.$publicData.clientUrl + '/xianli/publish?status='+ that.status
							}
						}
						that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

						})
					} else {
						// 未通过审核
						that.$router.push({
							path: '/xianli/publish',
							query: {
								status: that.status
							}
						})
					}
				}else{
					if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
						var params = {
							'data': {
								'url': that.$publicData.clientUrl + '/xianli/publish'
							}
						}
						that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

						})
					} else {
						// 发布献礼
						that.$router.push({
							path: '/xianli/publish'
						})
					}
					
				}
			}
		},
		// 用户判断我是否发布献礼,及状态
		getUserPublishState(){
			var that = this
			var params = {
				token: that.token
			}
			that.$api.xianli.ispublish(params).then(res=>{
				if(res.code == 200){
					that.is_publish = res.result.is_publish // 0未发布过 1发布过
					that.status = res.result.status // 文章状态0未审核 1审核通过 -1未通过
				}
			})
		},
		// 展开大图 
        zhanshitupian( arr, index) {
			var that = this;
			for(let i in arr){
				arr[i] = this.imageUrl + arr[i];
			};
			// console.log('展开大图', arr, index)
            if (index == 3 && that.images_hide) {
                that.images_hide = false
                return
            }
            that.bigTuImgArr = arr;
            that.bigTuIndex = index;
            that.bigTuShow = true;
        },
		// 切换大图
        bigTuChange(index) {
			var that = this
            that.bigTuIndex = index
        },
		// 去助力
		bindZhuli(){
			this.showEndZhuli()
			return
			var that = this
			if(that.info.is_help){
				return
			}else{
				var params = {
					token: that.token,
					articleid: that.articleid
				}
				that.$api.xianli.help(params).then(res=>{
					if(res.code == 200){
						that.$toast(res.message)
						// 重新拉取详情
						that.getData()
					}
				})
			}
		},
		// 回首页
		goXianliIndex(){
			var that = this
			if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
				var params = {}
				that.$bridge.callhandler('sdjy://public/back', params, (data) => {

				})
			} else {
				that.$router.push('/xianli/index')
			}
		},
		// 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: that.info.content, // 分享标题
                    desc: that.info.describe, // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.imageUrl + that.info.thumb, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
		}
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
